const CASES = [
  {
    tag: "01 / FRAME BENCH",
    title: "Set-Up & Measure Labor",
    body: "Carrier denied 3-dimensional electronic measuring time. Brim cited OEM unibody tolerance requirements.",
    img: "https://images.pexels.com/photos/34337558/pexels-photo-34337558.jpeg",
    alt: "High precision structural alignment rack in an auto body facility",
  },
  {
    tag: "02 / COLOR MATCH",
    title: "Spray Out Test Cards",
    body: "Adjuster cut test spray times. Rebuttal cited paint manufacturer technical data sheet specifications.",
    img: "https://images.pexels.com/photos/30250199/pexels-photo-30250199.jpeg",
    alt: "Paint technician matching OEM tri-coat formula in a mixing lab",
  },
  {
    tag: "03 / ADAS RADAR",
    title: "Dynamic Calibration Drive",
    body: "Carrier cut driving labor for radar learn mode. Precedent database validated line item immediately.",
    img: "https://images.pexels.com/photos/16303695/pexels-photo-16303695.jpeg",
    alt: "Scan tool diagnostic cable plugged into a vehicle OBD-II port",
  },
];

const Gallery = () => (
  <section className="py-12 bg-[#FAF8F5] border-b border-[#E7E5E4]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CASES.map((c, i) => (
          <div
            key={c.tag}
            data-testid={`case-card-${i + 1}`}
            className="rounded-lg border border-stone-200 bg-white overflow-hidden shadow-sm hover:shadow-md transition-shadow group"
          >
            <div className="h-44 overflow-hidden">
              <img
                src={c.img}
                alt={c.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5 space-y-3">
              <span className="text-xs font-mono-ui text-[#9A3412] font-semibold">
                {c.tag}
              </span>
              <h4 className="font-bold text-stone-900 font-serif-display">
                {c.title}
              </h4>
              <p className="text-xs text-stone-600 leading-relaxed">{c.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
